'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'comet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e003';
var svgPathData = ['M16 309c0 103.3 83.7 187 187 187 66.7 0 128.4-35.6 161.8-93.3L466.9 226.3c-20.6 1.6-38.7 3-54.2 4.2l8.3-23.2 64.6-180.8-180.8 64.6-23.2 8.3c1.2-15.6 2.6-33.6 4.2-54.2L109.3 147.2C51.6 180.6 16 242.3 16 309zm56-28.6c5.4-.8 34.8-5 88.4-12.7 24-48 37.2-74.3 39.6-79 2.4 4.7 15.5 31 39.6 79 53.6 7.7 83.1 11.9 88.4 12.7-4 3.8-25.3 24.3-64 61.5 9.1 52.6 14.2 81.5 15.1 86.8-4.7-2.4-31-16.1-79.1-41-48.1 24.9-74.4 38.6-79.1 41 .9-5.3 6-34.3 15.1-86.8-38.7-37.2-60-57.7-64-61.5z', 'M302.5 35.3c-1.3 16.3-2.3 29.9-3.1 40.6L315.9 70 492.5 7 512 0 505 19.5 442 196.1 436.1 212.6c25-1.9 53.4-4.1 59.9-4.6l-9.7 16.8-107.6 185.9C342.3 473.4 275.4 512 203 512 90.9 512 0 421.1 0 309 0 236.6 38.6 169.7 101.3 133.4L287.2 25.7 304 16 302.5 35.3zM304.8 91l-23.2 8.3c1.2-15.6 2.6-33.6 4.2-54.2L109.3 147.2c-57.7 33.4-93.3 95.1-93.3 161.8 0 103.3 83.7 187 187 187 66.7 0 128.4-35.6 161.8-93.3L466.9 226.3c-20.6 1.6-38.7 3-54.2 4.2L421 207.2 485.6 26.4 304.8 91zM208.9 206.7l30.6 61.1c53.6 7.7 83.1 11.9 88.4 12.7-4 3.8-25.3 24.3-64 61.5 9.1 52.6 14.2 81.5 15.1 86.8-4.7-2.4-31-16.1-79.1-41-48.1 24.9-74.4 38.6-79.1 41 .9-5.3 6-34.3 15.1-86.8-38.7-37.2-60-57.7-64-61.5 5.4-.8 34.8-5 88.4-12.7 24-48 37.2-74.3 39.6-79l8.9 17.9zm28.3 77l-8.3-1.2-3.7-7.5-25.2-50.4-25.2 50.4-3.7 7.5-8.3 1.2-56 8 40.3 38.8 6.1 5.9-1.5 8.4-9.6 55 50.5-26.1 7.4-3.8 7.4 3.8 50.4 26.1-9.6-55-1.5-8.4 6.1-5.9 40.3-38.8-56-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;